import { createSlice } from "@reduxjs/toolkit";

const evaluationSlice = createSlice({
  name: "evaluation",
  initialState: {
    status: "idle",
    error: null,
    loading: false,
    evaluationLoading: false,
    evaluationError: null,
    // Evaluation tasks and status
    evaluationTasks: [],
    currentTask: null,
    taskStatus: null,
    // JD evaluation specific
    jdEvaluationTasks: [],
    jdEvaluationStatus: null,
    // Client evaluation specific
    clientEvaluationTasks: [],
    clientEvaluationStatus: null,
    // Bulk evaluation specific
    bulkEvaluationTasks: [],
    bulkEvaluationStatus: null,
    // Evaluation results
    evaluationResults: [],
    // JD matches
    jdMatches: {},
    // Evaluation analytics
    evaluationAnalytics: null
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setEvaluationLoading: (state, action) => {
      state.evaluationLoading = action.payload;
    },
    setEvaluationError: (state, action) => {
      state.evaluationError = action.payload;
    },
    // Evaluation tasks
    setEvaluationTasks: (state, action) => {
      state.evaluationTasks = action.payload;
    },
    setCurrentTask: (state, action) => {
      state.currentTask = action.payload;
    },
    setTaskStatus: (state, action) => {
      state.taskStatus = action.payload;
    },
    // JD evaluation
    setJDEvaluationTasks: (state, action) => {
      state.jdEvaluationTasks = action.payload;
    },
    setJDEvaluationStatus: (state, action) => {
      state.jdEvaluationStatus = action.payload;
    },
    // Client evaluation
    setClientEvaluationTasks: (state, action) => {
      state.clientEvaluationTasks = action.payload;
    },
    setClientEvaluationStatus: (state, action) => {
      state.clientEvaluationStatus = action.payload;
    },
    // Bulk evaluation
    setBulkEvaluationTasks: (state, action) => {
      state.bulkEvaluationTasks = action.payload;
    },
    setBulkEvaluationStatus: (state, action) => {
      state.bulkEvaluationStatus = action.payload;
    },
    // Evaluation results
    setEvaluationResults: (state, action) => {
      state.evaluationResults = action.payload;
    },
    // JD matches
    setJDMatches: (state, action) => {
      state.jdMatches = action.payload;
    },
    // Evaluation analytics
    setEvaluationAnalytics: (state, action) => {
      state.evaluationAnalytics = action.payload;
    },
    // Clear evaluation state
    clearEvaluationState: (state) => {
      state.status = "idle";
      state.error = null;
      state.loading = false;
      state.evaluationLoading = false;
      state.evaluationError = null;
      state.evaluationTasks = [];
      state.currentTask = null;
      state.taskStatus = null;
      state.jdEvaluationTasks = [];
      state.jdEvaluationStatus = null;
      state.clientEvaluationTasks = [];
      state.clientEvaluationStatus = null;
      state.bulkEvaluationTasks = [];
      state.bulkEvaluationStatus = null;
      state.evaluationResults = [];
      state.jdMatches = {};
      state.evaluationAnalytics = null;
    }
  },
});

export const {
  setError,
  setLoading,
  setEvaluationLoading,
  setEvaluationError,
  setEvaluationTasks,
  setCurrentTask,
  setTaskStatus,
  setJDEvaluationTasks,
  setJDEvaluationStatus,
  setClientEvaluationTasks,
  setClientEvaluationStatus,
  setBulkEvaluationTasks,
  setBulkEvaluationStatus,
  setEvaluationResults,
  setJDMatches,
  setEvaluationAnalytics,
  clearEvaluationState
} = evaluationSlice.actions;

// Selectors
export const selectEvaluationLoading = (state) => state.evaluation.evaluationLoading;
export const selectEvaluationError = (state) => state.evaluation.evaluationError;
export const selectEvaluationTasks = (state) => state.evaluation.evaluationTasks;
export const selectCurrentTask = (state) => state.evaluation.currentTask;
export const selectTaskStatus = (state) => state.evaluation.taskStatus;
export const selectJDEvaluationTasks = (state) => state.evaluation.jdEvaluationTasks;
export const selectJDEvaluationStatus = (state) => state.evaluation.jdEvaluationStatus;
export const selectClientEvaluationTasks = (state) => state.evaluation.clientEvaluationTasks;
export const selectClientEvaluationStatus = (state) => state.evaluation.clientEvaluationStatus;
export const selectBulkEvaluationTasks = (state) => state.evaluation.bulkEvaluationTasks;
export const selectBulkEvaluationStatus = (state) => state.evaluation.bulkEvaluationStatus;
export const selectEvaluationResults = (state) => state.evaluation.evaluationResults;
export const selectJDMatches = (state) => state.evaluation.jdMatches;
export const selectEvaluationAnalytics = (state) => state.evaluation.evaluationAnalytics;

export default evaluationSlice.reducer;
